/** Telegram Mini App yordamchilari. Rasmiy skript (telegram-web-app.js) faqat kerak bo'lganda yuklanadi. */

export interface TgWebApp {
  initData: string;
  themeParams: Record<string, string | undefined>;
  colorScheme?: "light" | "dark";
  ready(): void;
  expand(): void;
  close(): void;
  BackButton: {
    show(): void;
    hide(): void;
    onClick(cb: () => void): void;
    offClick(cb: () => void): void;
  };
  onEvent(event: string, cb: () => void): void;
  offEvent(event: string, cb: () => void): void;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TgWebApp };
  }
}

const SCRIPT_URL = "https://telegram.org/js/telegram-web-app.js";
const FLAG = "ep.tg";

export const getWebApp = (): TgWebApp | null => window.Telegram?.WebApp ?? null;

/** Mini App ichida ochilganmi: Telegram URL hash'iga `tgWebAppData` qo'shadi; keyin tab bayrog'i eslab qoladi. */
export function isTelegramLaunch(hash: string, flag: string | null): boolean {
  return hash.includes("tgWebAppData") || flag === "1";
}

export function readFlag(): string | null {
  try {
    return sessionStorage.getItem(FLAG);
  } catch {
    return null;
  }
}

export function markTelegram(): void {
  try {
    sessionStorage.setItem(FLAG, "1");
  } catch {
    /* private rejim: bayroqsiz ham ishlaydi */
  }
}

/** Skriptni yuklaydi (yoki tayyor bo'lsa shuni qaytaradi). Yuklanmasa/Telegram emas — `null`. */
export function loadTelegram(timeoutMs = 5000): Promise<TgWebApp | null> {
  const ready = getWebApp();
  if (ready) return Promise.resolve(ready);
  return new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = SCRIPT_URL;
    s.async = true;
    const timer = window.setTimeout(() => resolve(getWebApp()), timeoutMs);
    s.onload = () => {
      window.clearTimeout(timer);
      resolve(getWebApp());
    };
    s.onerror = () => {
      window.clearTimeout(timer);
      resolve(null);
    };
    document.head.appendChild(s);
  });
}

const HEX = /^#[0-9a-fA-F]{6}$/;

/** Telegram mavzu ranglarini bizning CSS o'zgaruvchilarimizga. Faqat to'g'ri HEX qabul qilinadi (CSS in'ektsiyasidan himoya). */
export function themeToCssVars(p: Record<string, string | undefined>): Record<string, string> {
  const pick = (...keys: string[]) =>
    keys.map((k) => p[k]).find((v): v is string => !!v && HEX.test(v));
  const map: [string, string | undefined][] = [
    ["--background", pick("secondary_bg_color", "bg_color")],
    ["--card", pick("bg_color")],
    ["--foreground", pick("text_color")],
    ["--muted", pick("secondary_bg_color")],
    ["--muted-foreground", pick("hint_color")],
    ["--primary", pick("button_color")],
    ["--primary-foreground", pick("button_text_color")],
    ["--ring", pick("button_color")],
    ["--border", pick("section_separator_color")],
  ];
  return Object.fromEntries(map.filter((e): e is [string, string] => !!e[1]));
}

export function applyTheme(w: TgWebApp, root: HTMLElement = document.documentElement): void {
  root.classList.toggle("dark", w.colorScheme === "dark");
  for (const [k, v] of Object.entries(themeToCssVars(w.themeParams ?? {})))
    root.style.setProperty(k, v);
}
